document.addEventListener("DOMContentLoaded", function () {
  /* sticky banner */
  const stickyImageSection = document.querySelectorAll(
    ".banner.sticky-section"
  );
  function checkSectionPosition() {
    stickyImageSection.forEach((section) => {
      const rect = section.getBoundingClientRect();
      if (rect.top <= 0) {
        section
          .querySelector(".banner__media")
          .classList.remove("fixed--media-box");
      } else {
        section
          .querySelector(".banner__media")
          .classList.add("fixed--media-box");
      }
    });
  }
  window.addEventListener("scroll", checkSectionPosition);

  /* sticky video */
  const stickyVideoSection = document.querySelectorAll(".sticky-video-section");
  function checkVideoPosition() {
    stickyVideoSection.forEach((section) => {
      const rect = section.getBoundingClientRect();
      if (rect.top <= 0) {
        section
          .querySelector(".video-section")
          .classList.remove("fixed-video-box");
      } else {
        section
          .querySelector(".video-section")
          .classList.add("fixed-video-box");
      }
    });
  }
  window.addEventListener("scroll", checkVideoPosition);

  /* product description close */
  var productDescription = document.querySelector(".product__description");
  if (productDescription) {
    function updateHeight() {
      var height = productDescription.scrollHeight;
      productDescription.style.height = height + "px";
    }
    function handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > 0) {
        productDescription.classList.add("slide-up");
        AOS.refresh();
      } else {
        productDescription.classList.remove("slide-up");
        AOS.refresh();
      }
    }
    updateHeight();
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("load", handleScroll);
    window.addEventListener("resize", updateHeight);
  }

  /* splash screen */
  const splashScreen = document.querySelector(".splash-screen-main");
  if (splashScreen) {
    splashScreen.classList.add("slideUpHide");
  }

  /* mega menu hover */
  // document.querySelectorAll("details.mega-menu").forEach((details) => {
  //   const summary = details.querySelector("summary");
  //   const megaMenuContent = details.querySelector(".mega-menu__content");
  //   let isMouseInside = false;
  //   const closeMenu = () => {
  //     if (!isMouseInside) {
  //       details.open = false;
  //     }
  //   };
  //   summary.addEventListener("mouseenter", () => {
  //     details.open = true;
  //     isMouseInside = true;
  //   });
  //   megaMenuContent.addEventListener("mouseenter", () => {
  //     isMouseInside = true;
  //     details.open = true;
  //   });
  //   summary.addEventListener("mouseleave", () => {
  //     isMouseInside = false;
  //     setTimeout(closeMenu, 100);
  //   });
  //   megaMenuContent.addEventListener("mouseleave", () => {
  //     isMouseInside = false;
  //     setTimeout(closeMenu, 100);
  //   });
  // });

  /* open first mega menu by default */
  const drawerContainer = document.querySelector(".menu-drawer-container");

  // Event listener for when the drawer menu is toggled (opened/closed)
  drawerContainer.addEventListener("toggle", () => {
    // Check if the drawer menu is open
    if (drawerContainer.open) {
      // Select the first mega menu inside the drawer
      const firstMegaMenu = drawerContainer.querySelector("details.mega-menu");

      // Open the first mega menu if it exists and is not already opens
      if (firstMegaMenu && !firstMegaMenu.open) {
        firstMegaMenu.open = true;
      }
    }
  });

  /* Aos init */
  function AosInit() {
    AOS.init({
      duration: 1000,
      offset: 80,
      once: true,
      easing: "ease",
    });
  }
  if (splashScreen) {
    setTimeout(function () {
      AosInit();
    }, 1200);
  } else {
    AosInit();
  }
  //  setTimeout(() => {
  //      document.querySelector('.site-preloader-box').classList.add('active');
  // }, 300);
});


/* grid position detector */
function detectGridPosition() {
  const spanElements = document.querySelectorAll(
    ".promotional-banner.grid__item"
  );
  const screenMidpoint = window.innerWidth / 2;
  const bufferZone = 50; // Define a buffer around the midpoint

  spanElements.forEach((element) => {
    const elementPosition = element.getBoundingClientRect();
    const elementMidpoint = elementPosition.left + elementPosition.width / 2;
    element.classList.remove("left-side", "right-side");

    if (elementMidpoint < screenMidpoint - bufferZone) {
      element.classList.add("left-side");
    } else if (elementMidpoint > screenMidpoint + bufferZone) {
      element.classList.add("right-side");
    }
  });
}
document.addEventListener("DOMContentLoaded", detectGridPosition);
window.addEventListener("resize", detectGridPosition);

document.querySelectorAll('.header .mega-menu__content .mega-menu-container .mega-menu__list .nav-child-link > a')
  .forEach(anchor => {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("class", "angle-right");
    svg.setAttribute("viewBox", "0 0 100 100");
    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", "M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z");
    path.setAttribute("class", "arrow");
    svg.appendChild(path);
    anchor.appendChild(svg);
  });

$('.header .mega-menu__content .mega-menu-container .mega-menu__list .nav-child-link > a').mouseenter(function (e) {
  e.preventDefault();
  $('.header .mega-menu__content .mega-menu-container .mega-menu__list .nav-child-link > a')
    .not(this)
    .removeClass('active')
    .siblings('.nav-grandchild-link')
    .slideUp();
  $(this).toggleClass('active');
  $(this).siblings('.nav-grandchild-link').slideToggle();
});


/* grid position detector */
function detectGridPosition() {
  const spanElements = document.querySelectorAll(
    ".promotional-banner.grid__item"
  );
  const screenMidpoint = window.innerWidth / 2;
  const bufferZone = 50; // Define a buffer around the midpoint

  spanElements.forEach((element) => {
    const elementPosition = element.getBoundingClientRect();
    const elementMidpoint = elementPosition.left + elementPosition.width / 2;
    element.classList.remove("left-side", "right-side");

    if (elementMidpoint < screenMidpoint - bufferZone) {
      element.classList.add("left-side");
    } else if (elementMidpoint > screenMidpoint + bufferZone) {
      element.classList.add("right-side");
    }
  });
}
document.addEventListener("DOMContentLoaded", detectGridPosition);
window.addEventListener("resize", detectGridPosition);



//Quick View JS
document.addEventListener('DOMContentLoaded', function () {
  // Select all elements matching the specified selector
  document.querySelectorAll('.style-width-container .quick-add__submit').forEach(function (button) {
    button.addEventListener('click', function () {
      // Trigger AOS refresh
      AOS.refresh();
    });
  });

  window.dispatchEvent(new Event('resize'));
});




// document.addEventListener('DOMContentLoaded', () => {
//     const detailsElements = document.getElementsByClassName('mobile-facets__submenu');
//     if (detailsElements.length > 0) {
//         for (let i = 0; i < detailsElements.length; i++) {
//             detailsElements[i].closest('details').setAttribute('open', '');
//         }
//     }
// });

// document.addEventListener('DOMContentLoaded', () => {
//    $('summary.header__menu-item').click(function(){
//      $(header .mega-menu__content).removeClass('active');
//      $(this).siblings(.mega-menu__content).addClass('active');
//    })

// });

// document.addEventListener('DOMContentLoaded', () => {
//     const menuItems = document.querySelectorAll('summary.header__menu-item');
//     menuItems.forEach(item => {
//         item.addEventListener('click', () => {
//             document.querySelectorAll('.mega-menu__content').forEach(content => {
//                 content.classList.remove('active');
//             });
//             const siblingContent = item.parentElement.querySelector('.mega-menu__content');
//             if (siblingContent) {
//                 siblingContent.classList.add('active');
//             }
//         });
//     });
// });


document.querySelectorAll('.mega-menu .header__menu-item').forEach(function (menuItem) {
  menuItem.addEventListener('click', function () {
    document.querySelectorAll('.mega-menu').forEach(function (menu) {
      menu.classList.remove('active');
    });
    document.querySelectorAll('.mega-menu .mega-menu__content').forEach(function (content) {
      content.classList.remove('active');
    });
    var megaMenu = menuItem.closest('.mega-menu');
    if (megaMenu) {
      megaMenu.classList.add('active');
    }
    var content = menuItem.nextElementSibling;
    while (content && !content.classList.contains('mega-menu__content')) {
      content = content.nextElementSibling;
    }
    if (content) {
      content.classList.add('active');
    }
  });

  menuItem.addEventListener('mouseover', function () {
    document.querySelectorAll('.mega-menu').forEach(function (menu) {
      menu.classList.remove('active');
    });
    document.querySelectorAll('.mega-menu .mega-menu__content').forEach(function (content) {
      content.classList.remove('active');
    });
    var megaMenu = menuItem.closest('.mega-menu');
    if (megaMenu) {
      megaMenu.classList.add('active');
    }
    var content = menuItem.nextElementSibling;
    while (content && !content.classList.contains('mega-menu__content')) {
      content = content.nextElementSibling;
    }
    if (content) {
      content.classList.add('active');
    }
  });
});

document.addEventListener('click', function (event) {
  var len = event.target.closest('.mega-menu__content, .header__menu-item');
  if (!len) {
    document.querySelectorAll('.mega-menu').forEach(function (menu) {
      menu.classList.remove('active');
    });
    document.querySelectorAll('.mega-menu .mega-menu__content').forEach(function (content) {
      content.classList.remove('active');
    });
  }
});

document.addEventListener('mouseover', function (event) {
  var len = event.target.closest('.mega-menu__content, .header__menu-item');
  if (!len) {
    document.querySelectorAll('.mega-menu').forEach(function (menu) {
      menu.classList.remove('active');
    });
    document.querySelectorAll('.mega-menu .mega-menu__content').forEach(function (content) {
      content.classList.remove('active');
    });
  }
});


document.querySelectorAll('.field').forEach((field) => {
  const errorMessage = field.querySelector('.error-message');
  if (!errorMessage) {
    field.classList.remove('error-field');
  } else {
    field.classList.add('error-field');
  }
});
